import(/* webpackMode: "eager" */ "/vercel/path0/app/(auth)/error.tsx");
